module.exports = __webpack_public_path__ + "img/ic_footer_social_youtube.1ea2c03b.svg";